const Pipeline = () => import("@/components/sight/Pipeline.vue");
const Dashboard = () => import("@/components/sight/Dashboard.vue");
const Alerts = () => import("@/components/sight/Alerts.vue");
const Currencies = () => import("@/components/sight/Currencies.vue");
const Profile = () => import("@/components/sight/Profile.vue");
const TargetCreate = () => import("@/components/sight/target/TargetCreate.vue");
const TargetDetail = () => import("@/components/sight/target/TargetDetail.vue");

const pipelineBranch = { navItem: "Pipeline" };

export default [
  { path: "", name: "Pipeline", component: Pipeline },
  { path: "dashboard", name: "Dashboard", component: Dashboard },
  { path: "alerts", name: "Alerts", component: Alerts },
  { path: "currencies", name: "Currencies", component: Currencies },
  { path: "profile", name: "Profile", component: Profile },
  { path: "targets/new", name: "TargetCreate", component: TargetCreate, meta: pipelineBranch },
  {
    path: "targets/:uuid",
    name: "TargetDetail",
    component: TargetDetail,
    props: true,
    meta: pipelineBranch,
  },
  {
    path: "targets/:uuid/edit",
    name: "TargetEdit",
    component: TargetCreate,
    props: true,
    meta: pipelineBranch,
  },
];
